var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 124,
    viewBox: "0 0 125 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 62C0.25 96.2417 28.0083 124 62.25 124C96.4917 124 124.25 96.2417 124.25 62C124.25 27.7583 96.4917 0 62.25 0C28.0083 0 0.25 27.7583 0.25 62Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7 46.8875C90.925 44.175 88.9875 42.2375 86.275 41.4625C81.625 40.3 61.8625 40.3 61.8625 40.3C61.8625 40.3 42.4875 40.3 37.45 41.4625C34.7375 42.2375 32.8 44.175 32.025 46.8875C31.25 51.925 31.25 62 31.25 62C31.25 62 31.25 72.075 32.4125 77.1125C33.1875 79.825 35.125 81.7625 37.8375 82.5375C42.4875 83.7 62.25 83.7 62.25 83.7C62.25 83.7 81.625 83.7 86.6625 82.5375C89.375 81.7625 91.3125 79.825 92.0875 77.1125C93.25 72.075 93.25 62 93.25 62C93.25 62 93.25 51.925 91.7 46.8875ZM56.05 71.3V52.7L72.325 62L56.05 71.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ec86c8e10085dd25ca76d5dd1f88aec3.svg";
export { ForwardRef as ReactComponent };